import CollectionsBootstrap from 'modules/complaints/lib/SettingsCollectionsBootstrap'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { BasicSettings } from './Content/BasicSettings'
import { PrivacyPolicy } from './Content/PrivacyPolicySettings'
import { PublicFormSettings } from './Content/PublicFormSettings'

const Container = () => {
  return (
    <ResponsivePage.Body>
      <BasicSettings />
      <PrivacyPolicy />
      <PublicFormSettings />
    </ResponsivePage.Body>
  )
}

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Container />
    </CollectionsBootstrap>
  )
}

export default RootPage
